import CIIExclusionCalculation from "./CIIDataForms/CIIExclusionsCalculation";

const CIIData = () => {
	return (
		<>
			<div className="mt-4">
				{" "}
				<CIIExclusionCalculation />
			</div>
		</>
	);
};

export default CIIData;
